import { useEffect } from "react";

export function useClickOutside(ref, onOutsideClick) {
  useEffect(() => {
    if (!ref?.current) return;

    const handler = (event) => {
      if (!ref.current.contains(event.target)) {
        onOutsideClick?.(event);
      }
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [ref, onOutsideClick]);
}
